__turbopack_context__.v({
  "container": "OtherProductsSection-module__4JiRba__container",
  "productActions": "OtherProductsSection-module__4JiRba__productActions",
  "productContent": "OtherProductsSection-module__4JiRba__productContent",
  "productDescription": "OtherProductsSection-module__4JiRba__productDescription",
  "productItem": "OtherProductsSection-module__4JiRba__productItem",
  "productTitle": "OtherProductsSection-module__4JiRba__productTitle",
  "root": "OtherProductsSection-module__4JiRba__root" + " " + __turbopack_context__.i(859805)["sectionMargin"],
});
